import React from 'react'
import DialogRouter from '../dialogs/dialogRouter';
import Grid from '@material-ui/core/Grid';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import VehicleSummary from './VehicleSummary';
import VehicleImage from './VehicleImage';
import ShowPreviewIcon from '@material-ui/icons/ZoomOutMap';
import { Link } from 'react-router-dom';
import { Location } from 'history';
import './vehicle-overview.scss';
import { mapStateToProps, mapDispatchToProps, StateManagementProps } from '../../utils/addReduxProps';
import { connect } from 'react-redux';
import PartDetailDialog, { PartDetailDialogProps } from '../parts/PartDetailDialog';
import Toast from '../shared/Toast';

export interface VehicleOverviewProps {
	location: Location;
};

export type VehicleOverviewAllProps = VehicleOverviewProps & WithNamespaces & StateManagementProps;

export const VehicleOverview: React.FunctionComponent<VehicleOverviewAllProps> =
	({
		t,
		selectedModel,
		views: { showPartDetail },
		toast,
		appliedSetup,
		applyParts,
		appliedParts,
		location: { pathname },
		totalPrice,
		models,
		setImageTimestamp,
		selectedPart,
		togglePartDetail,
		toggleSummary,
		deselectPart,
		setConfigurationImages,
	}) => {

		let Dialog: React.ReactNode;


		if (!selectedModel) {
			//@todo return page not found
			return null;
		}
		if (showPartDetail) {
			// show part detail dialog
			const dialogProps: PartDetailDialogProps = {
				setImageTimestamp,
				selectedPart,
				closeDialog: () => {
					togglePartDetail(false);
					deselectPart();
				},
				setConfigurationImages,
				applyParts,
				appliedParts,
			};
			Dialog = <PartDetailDialog {...dialogProps} ></PartDetailDialog>;
		}

		return (
			<Grid id="vehicle-overview-wrapper" container className="full-height" direction="column" justify="space-between">
				<Grid item container>
					<Grid item className="grow"></Grid>
					<Grid item>
						<Link to={{ pathname: "/preview", state: { from: pathname } }} >
							<ShowPreviewIcon className="preview-link"></ShowPreviewIcon>
						</Link>
					</Grid>
				</Grid>
				{/* central component section */}
				<Grid item className={`${showPartDetail ? '' : 'text-center'} grow`}>
					{showPartDetail ? Dialog : <VehicleImage />}
				</Grid>
				{/* summary section */}
				<Grid item >
					{!showPartDetail && <VehicleSummary
						model={selectedModel}
						appliedSetup={appliedSetup}
						appliedParts={appliedParts}
						totalPrice={totalPrice}
						hasPrices={models.ShowPricesInConfigurator}
					>
						{/* REVERT BUTTON'S DISABLED PROP WHEN SETUPS BECOME ACTIVE */}
						{/*  disabled={!appliedSetup} */}
						<button className="primary" disabled={false} onClick={() => toggleSummary(true)}>{t('buttons.viewConfiguration')}</button>
					</VehicleSummary>}
				</Grid>
				<DialogRouter />
				{showPartDetail && <div id="overlay"></div>}
				<Toast  {...toast} />
			</Grid>
		);
	}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(VehicleOverview));
